import {Model as BaseModel} from '@vuex-orm/core';
import * as pluralize from "pluralize";

export default class Model extends BaseModel {
    getSingularEntity(): string {
        return pluralize.singular(
            Object.getPrototypeOf(this).constructor.entity
        );
    }

    declare created_at: string;
    declare updated_at: string;
}
